// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-column {
  text-align: center;
  width: 45px;
  padding-right: 0;
}

.custom-table {
  height: 100%;
  overflow-y: scroll !important;
  overflow-x: hidden !important;
}

.header-row {
  width: 100% !important;
}

.export-row {
  flex-basis: 40px;
  min-height: 40px;
  margin-top: 5px;
  margin-bottom: 10px;
}

.content-panel {
  overflow-y: auto;
  overflow-x: auto;
  min-height: 0;
}

thead {
  color: #859296;
  font-family: Inter;
  font-style: normal;
  font-weight: bold;
  font-size: 10.5px;
}

tbody {
  overflow-y: auto !important;
  background-color: #FFFFFF;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 11.4px;
  color: #859296;
}

.tbody-export {
  max-height: calc(100vh - 50px) !important;
}

th {
  position: sticky;
}

.table thead th {
  border-top: none;
  position: sticky;
  top: 0;
  background: #F3F3F3;
  z-index: 1;
  vertical-align: middle !important;
}

th.desc:after {
  transform: rotate(180deg);
  -ms-transform: rotate(180deg);
}

th.desc:after, th.asc:after {
  content: url("data:image/svg+xml; utf8, <svg width='11' height='9' viewBox='0 0 9 10' fill='none' xmlns='http://www.w3.org/2000/svg'> <g> <path d='M3.76708 0.531373V8.20932' stroke='%2302B9F1'/> <path d='M0.541931 6.7587L3.76706 8.94208L6.68283 6.7587' stroke='%2302B9F1'/> </g> </svg>");
  width: -moz-fit-content;
  width: fit-content;
  margin-left: 5px;
  height: 13px;
  display: inline-block;
  vertical-align: text-bottom;
}

.table td, .table th {
  vertical-align: middle !important;
  padding: 0.5rem 0.4rem;
}

table {
  display: flex;
  flex-flow: column;
  height: 100%;
  width: 100%;
}

table thead {
  /* head takes the height it requires,
  and it's not scaled when table is resized */
  flex: 0 0 auto;
  width: calc(100% - 0.9em);
}

table tbody {
  /* body takes all the remaining available space */
  border-top: 2px solid var(--theme-main-border-color, #055C8D);
  flex: 1 1 auto;
  display: block;
  overflow-y: scroll;
}

table tbody tr {
  width: 100%;
}

table thead, table tbody tr {
  display: table;
  table-layout: fixed;
}

.table-link {
  color: var(--theme-active-color, #243391);
  cursor: pointer;
}

.table-link:hover {
  text-decoration: underline;
}

td {
  word-wrap: break-word;
  white-space: pre-line;
}

.filter {
  height: auto;
  min-width: -moz-fit-content;
  min-width: fit-content;
}

input[type=radio], input[type=checkbox] {
  z-index: 1;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #859296;
  background-color: var(--theme-main-background-color, #055C8D);
}

.selectable-row {
  cursor: pointer;
}

.radio-button-column {
  width: 48px !important;
}

.recipient-type-labels-padding {
  padding-top: 5px;
}

.recipient-type-radio-btn-margins {
  margin-left: 8px;
}

.footer {
  margin-top: 3px;
  flex-direction: row;
  justify-content: flex-end;
  height: 52px;
  padding: 9px 5px 2px 5px;
  position: fixed;
  bottom: 0px;
}

.filename-text {
  width: 250px;
  padding: 5px;
  margin-right: 10px;
}

.workflow-form-label {
  padding-right: 5px;
  color: var(--theme-active-color, #243391);
  font-family: Inter, sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.305883px;
  white-space: nowrap;
}

.border {
  width: 100%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
